export const COMPANY_SIZES = [
  '0–100 Mitarbeitende',
  '101–500 Mitarbeitende',
  '501–2.000 Mitarbeitende',
  'Über 2.000 Mitarbeitende'
];

export const COMPANY_TYPES = [
  'Sparkasse/Sparkassenverbund',
  'Genossenschaftsbank (Volksbank, Raiffeisenbank)',
  'privaten Geschäftsbank (z. B. Deutsche Bank, Commerzbank)',
  'Landesbank/Förderbank (z. B. KfW, NRW.BANK)',
  'Bausparkasse',
  'Versicherung',
  'Fondsgesellschaft/Vermögensverwaltung',
  'FinTech/Zahlungsdienstleister',
  'sonstigen Finanzdienstleister',
  'sonstigen Unternehmen'
];

export const ROLES = ['Geschäftsführung/Vorstand', 'Leitende:r Angestellte:r', 'Angestellte:r'];

/** Nominativ-Anzeigeformen der COMPANY_TYPES-Werte. Die gespeicherten Werte
 * sind teils Dativ-Fragmente, die den Satz „Sie arbeiten bei einer/einem …"
 * (context-page.tsx) vervollständigen, und bleiben aus Benchmark-Gründen
 * unverändert. Für die alleinstehende Anzeige (Ergebnisseite, PDF-Cover)
 * braucht es die Nominativform — sonst steht dort „Institut: sonstigen
 * Unternehmen". Nur grammatisch abweichende Werte sind gelistet. */
export const COMPANY_TYPE_DISPLAY: Record<string, string> = {
  'privaten Geschäftsbank (z. B. Deutsche Bank, Commerzbank)':
    'Private Geschäftsbank (z. B. Deutsche Bank, Commerzbank)',
  'sonstigen Finanzdienstleister': 'Sonstiger Finanzdienstleister',
  'sonstigen Unternehmen': 'Sonstiges Unternehmen'
};
